import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import locale_en from './translations/en-us.json';
import locale_no from './translations/no-nb.json';


export function useAppWideI18n(): [{ [key: string]: Record<string, string> }, [string, React.Dispatch<string>]] {
  const messages = {
    en: locale_en,
    no: locale_no,
  } as { [key: string]: Record<string, string> };

  const languageState = useState(navigator.language.split(/[-_]/)[0]);

  return [messages, languageState]
}

export function useTranslation() {
  const t = useIntl();
  return (key: string, args?: any) => {
    return t.formatMessage({ id: key }, args);
  }
}
